import { ErrorStateVariant } from "@/components/errorState/types";

// Offline is an expected outcome, not an app error — capturing it would recreate the noise the abort/network taxonomy removes. Connection and server failures are real signal.
export const shouldCaptureRenderError = (variant: ErrorStateVariant) =>
  variant === "connection" || variant === "server";
